export class Payment {

    public id: number;
    public reservation_id: number;
    public user_id: number;
    public amount: number;
    public type: string;
    public card_type: string;
    public card_ending: string;
    public square_payment_id: string;
    public square_receipt_number: string;
    public created: string;

    constructor(id: number, reservation_id: number, user_id: number, amount: number, type: string,
                card_type: string, card_ending: string,
                square_payment_id: string, square_receipt_number: string, created: string) {
        this.id = id;
        this.reservation_id = reservation_id;
        this.user_id = user_id;
        this.amount = amount;
        this.type = type;
        this.card_type = card_type;
        this.card_ending = card_ending;
        this.square_payment_id = square_payment_id;
        this.square_receipt_number = square_receipt_number;
        this.created = created;
    }
}

export class PaymentCreate {

    public reservation_id: number;
    public user_id: number;
    public amount: number;
    public type: string;
    public card_type: string;
    public card_ending: string;
    public square_payment_id: string;
    public square_receipt_number: string;

    constructor(reservation_id: number, user_id: number, amount: number, type: string,
                card_type: string, card_ending: string,
                square_payment_id: string, square_receipt_number: string) {
        this.reservation_id = reservation_id;
        this.user_id = user_id;
        this.amount = amount;
        this.type = type;
        this.card_type = card_type;
        this.card_ending = card_ending;
        this.square_payment_id = square_payment_id;
        this.square_receipt_number = square_receipt_number;
    }
}
